import React,{ useEffect, useState } from "react"
import { useHourlyActiveUser } from "../../hooks/useHourlyActiveUser"
import moment from "moment"
import _ from 'lodash'
import ReactECharts from 'echarts-for-react';
import active_user_bg from './img/active_user.svg'
import * as echarts from 'echarts/core';
import { blue } from "../../theme/colors";
import { useHitRate } from "../../hooks/useHitRate";
// import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import advantage from './img/advantage.svg'
import tile_bg from './img/tile_bg.svg'
import tile_bg_1 from './img/tile_bg_1.svg'
import tile_bg_2 from './img/tile_bg_2.svg'
import tile_bg_3 from './img/tile_bg_3.svg'
import tile_bg_4 from './img/tile_bg_4.svg'
import Spacer from "../../components/Spacer";
import { useTranslation } from "react-i18next";
const Tile:React.FC<{tile_head_bg:string,title:string,description:string}> = ({tile_head_bg,title,description})=>{
  return <div style={{position:'relative'}}>
    <img src={tile_bg} style={{width:'100%'}}/>
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',position:'absolute',left:0,right:0,top:0,bottom:0}}>
      <img style={{alignSelf:'center',width:'40%',display:'flex',paddingTop:'10%',marginBottom:'10%'}} src={tile_head_bg}/>
        
      <div style={{marginTop:'5%',fontSize:15,marginLeft:10,marginRight:10,color:blue[900],textAlign:'center'}}>
      
      {title}
      </div>
      <div style={{marginLeft:10,fontSize:12,marginRight:10}}>
      {description}
      </div>
    </div>
  </div>
}
export const Advantages = ()=>{
    const {data:hitRates,refresh} = useHitRate()
    const [chartData,setChartData] = useState<number[]>()
    const [xAxisData,setXAxisData]= useState<string[]>()
    const [rate,setRate] = useState(0)
    useEffect(()=>{
      let i = setInterval(() => {
        // setRate(_.random(80,96))
        refresh()
      }, 60*1000);
      return ()=>clearInterval(i)
    })
    useEffect(()=>{
      if(!hitRates){
        return
      }
      if(hitRates.length>0){
        const hr = hitRates[0].hitRate
        if(hr){
          setRate(hr)
        }
      }
      
    },[hitRates])
    const {t} = useTranslation()
    if(!rate){
      return <></>
    }
    return <div style={{alignSelf:'stretch',position:'relative'}}>
      <div style={{display:'flex',flexDirection:'row',alignItems:'center',fontWeight:'bold'}}> 
        <img src={advantage} style={{width:20,height:20,marginLeft:10,marginRight:10}}/>{t('Our Advantages')}
      </div> 
      {/* <div style={{alignSelf:'stretch',backgroundColor:'white',borderRadius:10,margin:10,height:210,boxShadow:'0px 6px 12px rgba(0, 0, 0, 0.08)'}}>
         
      </div> */}
      <div style={{height:10}}/>
      <div style={{display:'flex',flexDirection:'row',marginLeft:10,marginRight:10}}>
        <Tile tile_head_bg={tile_bg_1} title={t('Real-time Data Updates')} description={t('Provides the latest draw data to ensure users receive first-hand information.')}/>
        <div style={{width:10}}/>
        <Tile tile_head_bg={tile_bg_2} title={t('Intelligent Algorithm Analysis')} description={t('Combines big data and AI algorithms to improve prediction accuracy.')}/> 
       </div>
       <div style={{height:10}}/>
       <div style={{display:'flex',flexDirection:'row',marginLeft:10,marginRight:10}}>
        <Tile tile_head_bg={tile_bg_3} title={t('Expert Recommendations')} description={t('Integrates insights from professional analysts to provide precise recommendations.')}/>
        <div style={{width:10}}/>
        <Tile tile_head_bg={tile_bg_4} title={t('Secure & Reliable')} description={t('Utilizes encryption technology to protect user data and ensure security.')}/> 
       </div>
    </div>
  }